import React, { createContext, useContext, useState } from 'react';

export type Theme = 'light' | 'dark' | 'system';

interface ThemeContextType {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  resolvedTheme: 'light' | 'dark';
}

const ThemeContext = createContext<ThemeContextType | undefined>(undefined);

export const ThemeProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [theme, setThemeState] = useState<Theme>(() => {
    const saved = localStorage.getItem('theme');
    if (saved === 'dark' || saved === 'light' || saved === 'system') return saved;
    return 'system';
  });

  const [resolvedTheme, setResolvedTheme] = useState<'light' | 'dark'>('light');

  const setTheme = (newTheme: Theme) => {
    localStorage.setItem('theme', newTheme);
    setThemeState(newTheme);
  };

  // useEffect(() => {
  //   const root = window.document.documentElement;

  //   const updateTheme = () => {
  //     const active: 'light' | 'dark' =
  //       theme === 'system'
  //         ? window.matchMedia('(prefers-color-scheme: dark)').matches
  //           ? 'dark'
  //           : 'light'
  //         : theme;

  //     setResolvedTheme(active);

  //     if (active === 'dark') {
  //       root.classList.add('dark');
  //       root.style.colorScheme = 'dark';
  //     } else {
  //       root.classList.remove('dark');
  //       root.style.colorScheme = 'light';
  //     }
  //   };

  //   updateTheme();

  //   if (theme === 'system') {
  //     const mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
  //     const listener = () => updateTheme();
  //     mediaQuery.addEventListener('change', listener);
  //     return () => mediaQuery.removeEventListener('change', listener);
  //   }
  // }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme, resolvedTheme }}>
      {children}
    </ThemeContext.Provider>
  );
};

// eslint-disable-next-line react-refresh/only-export-components
export const useTheme = () => {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
};
